/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Sales_DescInputs */

const en_gc_editor_sales_desc = /** @type {(inputs: Gc_Editor_Sales_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tables, trends and a quarterly view.`)
};

const zh_gc_editor_sales_desc = /** @type {(inputs: Gc_Editor_Sales_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表格、趋势与季度数据。`)
};

/**
* | output |
* | --- |
* | "Tables, trends and a quarterly view." |
*
* @param {Gc_Editor_Sales_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_sales_desc = /** @type {((inputs?: Gc_Editor_Sales_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Sales_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_sales_desc(inputs)
	return zh_gc_editor_sales_desc(inputs)
});
export { gc_editor_sales_desc as "gc.editor.sales_desc" }